import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  fetchInvoice,
  createPaymentRequest,
  createInvoiceEmail,
  setStatus
} from 'redux/modules/payment';
import {
  SpinnerPage,
  PaymentPaid,
  PaymentStart,
  PaymentError,
  PaymentCancel,
  PaymentCredit
} from './index';
import { paidPaymentStatus, creditedPaymentStatus } from '../../frilans-finans/invoices/invoice-constants';

class PaymentPage extends React.Component {

  static propTypes = {
    params: PropTypes.any,
    payment: PropTypes.object.isRequired,
    fetchInvoice: PropTypes.func.isRequired,
    createPaymentRequest: PropTypes.func.isRequired,
    componentToRender: PropTypes.string,
    createInvoiceEmail: PropTypes.func.isRequired,
    setStatus: PropTypes.func.isRequired
  }

  componentDidMount = () => {
    this.props.fetchInvoice(this.props.params.uuid, ['calculation', 'users', 'pdf']);
  }

  cancel = () => {
    this.props.setStatus('cancelled');
  }

  render = () => {
    return (
      <div>
        {this.props.componentToRender === 'spinner' &&
          <SpinnerPage/>
        }
        {this.props.componentToRender === 'paid' &&
          <PaymentPaid invoice={this.props.payment.invoice} createInvoiceEmail={this.props.createInvoiceEmail} />
        }
        {this.props.componentToRender === 'start' &&
          <PaymentStart
            payment={this.props.payment}
            cancel={this.cancel}
            createPaymentRequest={this.props.createPaymentRequest} />
        }
        {this.props.componentToRender === 'error' &&
          <PaymentError payment={this.props.payment}/>
        }
        {this.props.componentToRender === 'cancel' &&
          <PaymentCancel payment={this.props.payment}/>
        }
        {this.props.componentToRender === 'credit' &&
          <PaymentCredit payment={this.props.payment}/>
        }
      </div>
    );
  }
}

const componentToRender = (payment) => {
  if (payment.invoice.status === 'error' || payment.paymentRequest.status === 'error') {
    return 'error';
  } else if (payment.status === 'cancelled') {
    return 'cancel';
  } else if (payment.invoice.status === 'success' &&
    payment.invoice.data.status === creditedPaymentStatus) {
    return 'credit';
  } else if (payment.invoice.status === 'success' &&
    payment.invoice.data.paymentStatus === paidPaymentStatus) {
    return 'paid';
  } else if (payment.invoice.status === 'success' &&
    payment.invoice.data.paymentStatus !== paidPaymentStatus) {
    return 'start';
  } else {
    return 'spinner';
  }
};

const mapStateToProps = ({payment}) => ({
  payment: payment,
  componentToRender: componentToRender(payment)
});

const mapDispatchToProps = {
  fetchInvoice,
  createPaymentRequest,
  createInvoiceEmail,
  setStatus
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPage);



/** WEBPACK FOOTER **
 ** ./src/views/payment/payment-page.js
 **/